import script from "./SoffitFascia07ExteriorLighting.vue?vue&type=script&setup=true&lang=js"
export * from "./SoffitFascia07ExteriorLighting.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__